import React from 'react'
import ApprovalListContainer from '../../containers/approvalmng/ApprovalListContainer'

const ApprovalListPage = () => {
  return <ApprovalListContainer/>
}

export default ApprovalListPage